import { render } from "./ArtInvestView.vue?vue&type=template&id=c702a6ee&scoped=true"
import script from "./ArtInvestView.vue?vue&type=script&lang=js"
export * from "./ArtInvestView.vue?vue&type=script&lang=js"

import "./ArtInvestView.vue?vue&type=style&index=0&id=c702a6ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c702a6ee"]])

export default __exports__